import Backdrop from "@material-ui/core/Backdrop";
import { CircularProgress } from "@mui/material";

const Loader = ({ isLoading }) => (
  <Backdrop
    sx={{ color: "#000", zIndex: 99999 }}
    open={isLoading ? isLoading : false}
  >
    <CircularProgress color="inherit" />
  </Backdrop>
);

export default Loader;
